import { render, staticRenderFns } from "./AspectAgreementForm.vue?vue&type=template&id=53949947&scoped=true"
import script from "./AspectAgreementForm.vue?vue&type=script&lang=js"
export * from "./AspectAgreementForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=53949947&prod&scoped=true&lang=css&external"
import style1 from "./AspectAgreementForm.vue?vue&type=style&index=1&id=53949947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53949947",
  null
  
)

export default component.exports